import { render, staticRenderFns } from "./CoffInputRadio.vue?vue&type=template&id=1006367f&scoped=true&"
import script from "./CoffInputRadio.vue?vue&type=script&lang=js&"
export * from "./CoffInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./CoffInputRadio.vue?vue&type=style&index=0&id=1006367f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1006367f",
  null
  
)

export default component.exports